// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XpNEIfNiy5DExSxDht8e {
  min-height: 100vh;
  background: #f7f7f7;
  padding: 20px;
}
.xJKDk4u1n08VMrYyEZCW {
  padding: 20px;
  width: 100%;
  text-align: center;
}
.xJKDk4u1n08VMrYyEZCW .afFEADwP07BMECiIb34T {
  width: 100%;
  height: auto;
  margin-bottom: 16px;
  margin: 0px auto 10px;
}
.FHAETA37IqcdSjNhS8zG {
  border: 0;
  border-top: 1px solid #e8e8e8;
  margin: 16px 0;
}
.OzBcosbQzSfpzLcmHCbh {
  padding: 20px;
  width: 100%;
}
.OzBcosbQzSfpzLcmHCbh .afFEADwP07BMECiIb34T {
  width: 100%;
  height: auto;
  margin-bottom: 16px;
  margin: 0px auto 10px;
}
.TZdL6chieinL9PrqEWkJ {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 16px;
}
.iSI3aZH08Al6D3bgzxjg {
  font-size: 12px;
  color: #333;
  line-height: 1.6;
  margin-top: 10px;
}
.NGeNFFSMr8JkMiGTJJFj {
  font-size: 12px;
  color: #333;
  line-height: 1.6;
  margin-top: 10px;
}
.Q1PpHkPuGNnLJRZJQbgS {
  width: 200px;
  /* 调整宽度 */
  text-align: center;
  /* 文本居中 */
  font-size: 16px;
  /* 字体大小 */
}
.Oelc6Qs0YnwnbMuHydEL {
  font-size: 12px;
  color: #666;
  margin-top: 16px;
}
.hCABMxDTIs_y5yg1mcNP {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-left: 5%;
}
.Oqn0pt54RdmBhuPIl13l {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #d9d9d9;
}
.CGqK2G1BEZeQtfuTLXBg {
  font-size: 16px;
  font-weight: 500;
  color: #1a1a1a;
}
.bbZaO9wxSiawVjfYzGpL {
  font-size: 14px;
  color: #666;
}
.KbF7_3IfapOw9DxXfkLA {
  text-align: center;
  width: 80%;
  margin: 0 auto;
}
.KbF7_3IfapOw9DxXfkLA .ant-input {
  margin-bottom: 16px !important;
}
.Og2i6L9sqDJ4w4RefYsV {
  font-size: 18px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 16px;
}
.n4EGs5k3UPX3evtD5YPy {
  text-align: center;
  margin-bottom: 16px;
}
.n4EGs5k3UPX3evtD5YPy .ant-input {
  height: 40px;
  border-radius: 4px;
  border: 1px solid #d9d9d9 !important;
  font-size: 14px;
}
.n4EGs5k3UPX3evtD5YPy .ant-input:focus {
  border-color: #79c9e3 !important;
  box-shadow: 0 0 0 2px rgba(121, 201, 227, 0.2) !important;
}
.aufEFCMFQjCe6wmhJidd .ant-btn.ant-btn-primary {
  background-color: #79c9e3 !important;
  border-color: #79c9e3 !important;
  border-radius: 4px !important;
  height: 40px !important;
  font-size: 16px !important;
  width: 100% !important;
  color: #fff !important;
  transition: background-color 0.3s !important;
  box-shadow: none !important;
}
.aufEFCMFQjCe6wmhJidd .ant-btn.ant-btn-primary:hover {
  background-color: #5db9d8 !important;
  border-color: #5db9d8 !important;
}
.aufEFCMFQjCe6wmhJidd .ant-btn.ant-btn-primary:focus {
  background-color: #79c9e3 !important;
  border-color: #79c9e3 !important;
}
.aufEFCMFQjCe6wmhJidd .ant-btn.ant-btn-primary:active {
  background-color: #5db9d8 !important;
  border-color: #5db9d8 !important;
}
.ant-modal .ant-modal-footer > .ant-btn + .ant-btn {
  margin-inline-start: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./../../ui-next/src/components/PhoneReport/components/styles/accessCode.module.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;AACF;AAEA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;AAAF;AAHA;EAMI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;AAAJ;AAIA;EACE,SAAA;EACA,6BAAA;EACA,cAAA;AAFF;AAKA;EACE,aAAA;EACA,WAAA;AAHF;AACA;EAKI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;AAHJ;AAOA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AALF;AAQA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AANF;AASA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAPF;AAUA;EACE,YAAA;EARA,SAAS;EAST,kBAAA;EAPA,SAAS;EAQT,eAAA;EANA,SAAS;AACX;AAsBA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AApBF;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AArBF;AAwBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAtBF;AAyBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAvBF;AA0BA;EACE,eAAA;EACA,WAAA;AAxBF;AA2BA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AAzBF;AAsBA;EAOM,8BAAA;AA1BN;AA+BA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA7BF;AAgCA;EACE,kBAAA;EACA,mBAAA;AA9BF;AA4BA;EAKM,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;AA9BN;AAsBA;EAYM,gCAAA;EACA,yDAAA;AA/BN;AAoCA;EAIM,oCAAA;EACA,gCAAA;EACA,6BAAA;EACA,uBAAA;EACA,0BAAA;EACA,sBAAA;EACA,sBAAA;EACA,4CAAA;EACA,2BAAA;AArCN;AAuCM;EACE,oCAAA;EACA,gCAAA;AArCR;AAwCM;EACE,oCAAA;EACA,gCAAA;AAtCR;AAyCM;EACE,oCAAA;EACA,gCAAA;AAvCR;AA6CA;EAEI,iCAAA;AA5CJ","sourcesContent":[".wrapper {\n  min-height: 100vh;\n  background: #f7f7f7;\n  padding: 20px;\n}\n\n.accessCodeContainer {\n  padding: 20px;\n  width: 100%;\n  text-align: center;\n\n  .hospitalImage {\n    width: 100%;\n    height: auto;\n    margin-bottom: 16px;\n    margin: 0px auto 10px;\n  }\n}\n\n.divider {\n  border: 0;\n  border-top: 1px solid #e8e8e8;\n  margin: 16px 0;\n}\n\n.accessCodeContainerPage {\n  padding: 20px;\n  width: 100%;\n\n  .hospitalImage {\n    width: 100%;\n    height: auto;\n    margin-bottom: 16px;\n    margin: 0px auto 10px;\n  }\n}\n\n.description {\n  font-size: 14px;\n  color: #333;\n  line-height: 1.6;\n  margin-bottom: 16px;\n}\n\n.tips {\n  font-size: 12px;\n  color: #333;\n  line-height: 1.6;\n  margin-top:10px;\n}\n\n.downloadtips{\n  font-size: 12px;\n  color: #333;\n  line-height: 1.6;\n  margin-top:10px;\n}\n\n.otpInput {\n  width: 200px; /* 调整宽度 */\n  text-align: center; /* 文本居中 */\n  font-size: 16px; /* 字体大小 */\n  // :global {\n  //   .ant-input {\n  //     text-align: center;\n  //     font-size: 16px;\n  //     height: 40px;\n  //     border-radius: 4px;\n  //     border: 1px solid #d9d9d9 !important;\n  //   }\n\n  //   .ant-input:focus {\n  //     border-color: #79c9e3 !important;\n  //     box-shadow: 0 0 0 2px rgba(121, 201, 227, 0.2) !important;\n  //   }\n  // }\n}\n\n.expiration {\n  font-size: 12px;\n  color: #666;\n  margin-top: 16px;\n}\n\n.userInfo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding-left:5%;\n}\n\n.avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #d9d9d9;\n}\n\n.userName {\n  font-size: 16px;\n  font-weight: 500;\n  color: #1a1a1a;\n}\n\n.examType {\n  font-size: 14px;\n  color: #666;\n}\n\n.downloadSection {\n  text-align: center;\n  width:80%;\n  margin:0 auto;\n\n  :global{\n    .ant-input{\n      margin-bottom: 16px !important;\n    }\n  }\n}\n\n.sectionTitle {\n  font-size: 18px;\n  font-weight: 500;\n  color: #1a1a1a;\n  margin-bottom: 16px;\n}\n\n.downloadInput {\n  text-align: center;\n  margin-bottom: 16px;\n  :global {\n    .ant-input {\n      height: 40px;\n      border-radius: 4px;\n      border: 1px solid #d9d9d9 !important;\n      font-size: 14px;\n    }\n\n    .ant-input:focus {\n      border-color: #79c9e3 !important;\n      box-shadow: 0 0 0 2px rgba(121, 201, 227, 0.2) !important;\n    }\n  }\n}\n\n.downloadButton {\n  :global {\n    // 提高选择器优先级，添加 .downloadButton 父类\n    .ant-btn.ant-btn-primary {\n      background-color: #79c9e3 !important; // 与 reportDetail.module.less 一致\n      border-color: #79c9e3 !important;\n      border-radius: 4px !important;\n      height: 40px !important;\n      font-size: 16px !important;\n      width: 100% !important;\n      color: #fff !important;\n      transition: background-color 0.3s !important;\n      box-shadow: none !important; // 移除 Tailwind 的默认阴影\n\n      &:hover {\n        background-color: #5db9d8 !important; // 鼠标悬停时加深\n        border-color: #5db9d8 !important;\n      }\n\n      &:focus {\n        background-color: #79c9e3 !important;\n        border-color: #79c9e3 !important;\n      }\n\n      &:active {\n        background-color: #5db9d8 !important;\n        border-color: #5db9d8 !important;\n      }\n    }\n  }\n}\n\n:global {\n  .ant-modal .ant-modal-footer > .ant-btn + .ant-btn {\n    margin-inline-start: 0 !important;\n  }\n}\n\n@primary-color: #1DA57A;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `XpNEIfNiy5DExSxDht8e`,
	"accessCodeContainer": `xJKDk4u1n08VMrYyEZCW`,
	"hospitalImage": `afFEADwP07BMECiIb34T`,
	"divider": `FHAETA37IqcdSjNhS8zG`,
	"accessCodeContainerPage": `OzBcosbQzSfpzLcmHCbh`,
	"description": `TZdL6chieinL9PrqEWkJ`,
	"tips": `iSI3aZH08Al6D3bgzxjg`,
	"downloadtips": `NGeNFFSMr8JkMiGTJJFj`,
	"otpInput": `Q1PpHkPuGNnLJRZJQbgS`,
	"expiration": `Oelc6Qs0YnwnbMuHydEL`,
	"userInfo": `hCABMxDTIs_y5yg1mcNP`,
	"avatar": `Oqn0pt54RdmBhuPIl13l`,
	"userName": `CGqK2G1BEZeQtfuTLXBg`,
	"examType": `bbZaO9wxSiawVjfYzGpL`,
	"downloadSection": `KbF7_3IfapOw9DxXfkLA`,
	"sectionTitle": `Og2i6L9sqDJ4w4RefYsV`,
	"downloadInput": `n4EGs5k3UPX3evtD5YPy`,
	"downloadButton": `aufEFCMFQjCe6wmhJidd`
};
export default ___CSS_LOADER_EXPORT___;
